import { httpsCallable } from "firebase/functions";
import { functions } from ".";

/**
 * Frontend callable wrapper for the automation rule manager Cloud Function.
 * All automation CRUD operations go through this single function with an action parameter.
 *
 * Supported actions: create, update, delete, get, list, pause, activate,
 * test, clone, getTemplates, createFromTemplate, getAnalytics, bulkUpdate
 *
 * @param {string} action - The CRUD action to perform
 * @param {object} params - Action-specific parameters (ruleId, ruleData, queryParameters, etc.)
 * @returns {object} The response from the Cloud Function
 */
export const automationRuleManager = async (action, params = {}) => {
	const func = httpsCallable(functions, "automationrulemanager", { timeout: 60000 });
	const res = await func({ action, ...params });
	return res.data;
};
